var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list-select"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87629 4.99995C6.87629 4.65478 7.15611 4.37495 7.50129 4.37495L16.668 4.37496C17.0131 4.37496 17.293 4.65478 17.293 4.99996C17.293 5.34513 17.0131 5.62496 16.668 5.62496L7.50129 5.62495C7.15611 5.62495 6.87629 5.34513 6.87629 4.99995Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59439 4.53447C4.85096 4.76538 4.87176 5.16056 4.64085 5.41713L4.63251 5.42639C4.4016 5.68296 4.00642 5.70376 3.74985 5.47285C3.49328 5.24193 3.47248 4.84675 3.7034 4.59018L3.71173 4.58093C3.94264 4.32436 4.33782 4.30356 4.59439 4.53447Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59439 9.53447C4.85096 9.76538 4.87176 10.1606 4.64085 10.4171L4.63251 10.4264C4.4016 10.683 4.00642 10.7038 3.74985 10.4728C3.49328 10.2419 3.47248 9.84675 3.7034 9.59018L3.71173 9.58092C3.94264 9.32436 4.33782 9.30356 4.59439 9.53447Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72603 14.3913C2.9701 14.1473 3.36583 14.1473 3.60991 14.3913L3.83463 14.6161L5.05935 13.3913C5.30343 13.1473 5.69916 13.1473 5.94323 13.3913C6.18731 13.6354 6.18731 14.0311 5.94323 14.2752L4.27657 15.9419C4.0325 16.186 3.63677 16.186 3.39269 15.9419L2.72603 15.2752C2.48195 15.0311 2.48195 14.6354 2.72603 14.3913Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87629 9.99995C6.87629 9.65478 7.15611 9.37495 7.50129 9.37495L16.668 9.37496C17.0131 9.37496 17.293 9.65478 17.293 9.99996C17.293 10.3451 17.0131 10.625 16.668 10.625L7.50129 10.625C7.15611 10.625 6.87629 10.3451 6.87629 9.99995Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87629 15C6.87629 14.6548 7.15611 14.375 7.50129 14.375H16.668C17.0131 14.375 17.293 14.6548 17.293 15C17.293 15.3451 17.0131 15.625 16.668 15.625H7.50129C7.15611 15.625 6.87629 15.3451 6.87629 15Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceLines);
export default __webpack_public_path__ + "static/media/source_lines.0707ffcc40774cf1d94c50c76a927f40.svg";
export { ForwardRef as ReactComponent };